import words from "./words"

const gameContent = {
	easy: words[0],
}

export default gameContent
